import { render, staticRenderFns } from "./clientUI.vue?vue&type=template&id=3aeb8e46&"
import script from "./clientUI.vue?vue&type=script&lang=js&"
export * from "./clientUI.vue?vue&type=script&lang=js&"
import style0 from "../assets/css/clientUI.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports